import type { BackendTypes } from '@tf/api';
import { Button, Flex, TextInput } from '@tf/ui';
import { fmt } from '@tf/utils';
import type React from 'react';
import { useState } from 'react';

import { useConfigContext } from '../../../../../hooks';

import { JobResultComment } from './index';

interface Props {
	comments: BackendTypes.AdhocComment[];
	onUpdateComments: (comments: BackendTypes.AdhocComment[]) => void;
}

export const JobResultComments: React.FC<Props> = ({ comments, onUpdateComments }) => {
	const { username } = useConfigContext((s) => s.apiConfig);

	const [newCommentText, setNewCommentText] = useState('');

	const addComment = () => {
		if (!newCommentText) {
			return;
		}

		const newComment: BackendTypes.AdhocComment = {
			date: fmt.toDate(new Date(), { preset: 'date_struct' }),
			comment: newCommentText,
			user: username,
		};

		onUpdateComments([...comments, newComment]);
		setNewCommentText('');
	};

	return (
		<>
			{comments.map((item, index) => (
				<JobResultComment key={index} username={item.user} date={item.date} comment={item.comment} />
			))}

			<Flex gap="sm">
				<TextInput
					flex={1}
					ref={(el) => el?.focus()}
					data-autofocus
					placeholder="New comment"
					value={newCommentText}
					onChange={(e) => setNewCommentText(e.target.value)}
					onKeyDown={async (e) => {
						if (e.key === 'Enter') {
							e.preventDefault();
							addComment();
						}
					}}
				/>
				<Button onClick={addComment}>Add</Button>
			</Flex>
		</>
	);
};
